export class RegexExp {
    static name = /^[a-zA-Z .]{1,}$/;
    static email = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    static phonenumber = /^[0-9]{10}$/
    static alphanumeric = /^[a-z0-9]+$/i
    static number = /^[0-9]*$/i
}
